export const NFCE_UNIDENTIFIED_VALUE_LIMIT = 9000;

export const NFCE_CANCELLATION_WINDOW_MINUTES = 30;

export const NFCE_CANCELLATION_JUSTIFICATION_MIN_LENGTH = 15;

export const NFCE_CANCELLATION_JUSTIFICATION_MAX_LENGTH = 255;
